module.exports = __webpack_public_path__ + "img/content11.4c53d10a.png";